export default __webpack_public_path__ + "static/triomed-1d736aa33fd6d0d78c37de2dfb474c31.png";